<section class="page-count__wrapper">
  <p class="t-data t-alt" tabindex="0">
    {{ paginationText }}
  </p>
  <ng-content></ng-content>
</section>
